import React, { useState, useEffect, useRef } from "react";
import { RouteComponentProps } from "react-router-dom";
import { StaticContext } from "react-router";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { Notification, Layout } from "../../../components";
import SettingsNavbar from "../../../components/SettingsNavbar";
import PasswordComponent from "../../../components/PasswordComponent";
import { getStripeCustomerInvoices, UpdateAWSAccount } from "../../../utils";
import { Container, SettingsRow, SalonColumn, InputContainer, FixedFooter, Tooltip } from "../style";
import mixpanel from 'mixpanel-browser';
import NativeSelect from '@material-ui/core/NativeSelect';
import { useSalons } from "../../../contexts/AdminContext";
import { getAllSalons } from "../../../actions/salonsActions";


interface IPathParams {
	salonId: string;
}

export default function AccountSettingsScreen ({
	history,
	match
}: React.PropsWithChildren<
	RouteComponentProps<IPathParams, StaticContext, any>
>) {
	const { salonId } = match.params;
	const [ account, setAccount ] = useState({}) as any;

	const [ invoices, setInvoices ] = useState({}) as any;
	const [ customer, setCustomer ] = useState({}) as any;
	const [ timezone, setTimezone ] = useState('') as any;
	const [ loading, setLoading ] = useState(true);
	const [ saving, setSaving ] = useState(false);
	const [ salon, setSalon ] = useState() as any;
	const timezones = ["Africa/Abidjan","Africa/Accra","Africa/Addis Ababa","Africa/Algiers","Africa/Asmara","Africa/Bamako","Africa/Bangui","Africa/Banjul","Africa/Bissau","Africa/Blantyre","Africa/Brazzaville","Africa/Bujumbura","Africa/Cairo","Africa/Casablanca","Africa/Ceuta","Africa/Conakry","Africa/Dakar","Africa/Dar es Salaam","Africa/Djibouti","Africa/Douala","Africa/El Aaiun","Africa/Freetown","Africa/Gaborone","Africa/Harare","Africa/Johannesburg","Africa/Juba","Africa/Kampala","Africa/Khartoum","Africa/Kigali","Africa/Kinshasa","Africa/Lagos","Africa/Libreville","Africa/Lome","Africa/Luanda","Africa/Lubumbashi","Africa/Lusaka","Africa/Malabo","Africa/Maputo","Africa/Maseru","Africa/Mbabane","Africa/Mogadishu","Africa/Monrovia","Africa/Nairobi","Africa/Ndjamena","Africa/Niamey","Africa/Nouakchott","Africa/Ouagadougou","Africa/Porto-Novo","Africa/Sao Tome","Africa/Tripoli","Africa/Tunis","Africa/Windhoek","America/Adak","America/Anchorage","America/Anguilla","America/Antigua","America/Araguaina","America/Argentina/Buenos Aires","America/Argentina/Catamarca","America/Argentina/Cordoba","America/Argentina/Jujuy","America/Argentina/La Rioja","America/Argentina/Mendoza","America/Argentina/Rio Gallegos","America/Argentina/Salta","America/Argentina/San Juan","America/Argentina/San Luis","America/Argentina/Tucuman","America/Argentina/Ushuaia","America/Aruba","America/Asuncion","America/Atikokan","America/Bahia","America/Bahia Banderas","America/Barbados","America/Belem","America/Belize","America/Blanc-Sablon","America/Boa Vista","America/Bogota","America/Boise","America/Cambridge Bay","America/Campo Grande","America/Cancun","America/Caracas","America/Cayenne","America/Cayman","America/Chicago","America/Chihuahua","America/Costa Rica","America/Creston","America/Cuiaba","America/Curacao","America/Danmarkshavn","America/Dawson","America/Dawson Creek","America/Denver","America/Detroit","America/Dominica","America/Edmonton","America/Eirunepe","America/El Salvador","America/Fort Nelson","America/Fortaleza","America/Glace Bay","America/Goose Bay","America/Grand Turk","America/Grenada","America/Guadeloupe","America/Guatemala","America/Guayaquil","America/Guyana","America/Halifax","America/Havana","America/Hermosillo","America/Indiana/Indianapolis","America/Indiana/Knox","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Tell City","America/Indiana/Vevay","America/Indiana/Vincennes","America/Indiana/Winamac","America/Inuvik","America/Iqaluit","America/Jamaica","America/Juneau","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Kralendijk","America/La Paz","America/Lima","America/Los Angeles","America/Lower Princes","America/Maceio","America/Managua","America/Manaus","America/Marigot","America/Martinique","America/Matamoros","America/Mazatlan","America/Menominee","America/Merida","America/Metlakatla","America/Mexico City","America/Miquelon","America/Moncton","America/Monterrey","America/Montevideo","America/Montserrat","America/Nassau","America/New York","America/Nipigon","America/Nome","America/Noronha","America/North Dakota/Beulah","America/North Dakota/Center","America/North Dakota/New Salem","America/Nuuk","America/Ojinaga","America/Panama","America/Pangnirtung","America/Paramaribo","America/Phoenix","America/Port-au-Prince","America/Port of Spain","America/Porto Velho","America/Puerto Rico","America/Punta Arenas","America/Rainy River","America/Rankin Inlet","America/Recife","America/Regina","America/Resolute","America/Rio Branco","America/Santarem","America/Santiago","America/Santo Domingo","America/Sao Paulo","America/Scoresbysund","America/Sitka","America/St Barthelemy","America/St Johns","America/St Kitts","America/St Lucia","America/St Thomas","America/St Vincent","America/Swift Current","America/Tegucigalpa","America/Thule","America/Thunder Bay","America/Tijuana","America/Toronto","America/Tortola","America/Vancouver","America/Whitehorse","America/Winnipeg","America/Yakutat","America/Yellowknife","Antarctica/Casey","Antarctica/Davis","Antarctica/DumontDUrville","Antarctica/Macquarie","Antarctica/Mawson","Antarctica/McMurdo","Antarctica/Palmer","Antarctica/Rothera","Antarctica/Syowa","Antarctica/Troll","Antarctica/Vostok","Arctic/Longyearbyen","Asia/Aden","Asia/Almaty","Asia/Amman","Asia/Anadyr","Asia/Aqtau","Asia/Aqtobe","Asia/Ashgabat","Asia/Atyrau","Asia/Baghdad","Asia/Bahrain","Asia/Baku","Asia/Bangkok","Asia/Barnaul","Asia/Beirut","Asia/Bishkek","Asia/Brunei","Asia/Chita","Asia/Choibalsan","Asia/Colombo","Asia/Damascus","Asia/Dhaka","Asia/Dili","Asia/Dubai","Asia/Dushanbe","Asia/Famagusta","Asia/Gaza","Asia/Hebron","Asia/Ho Chi Minh","Asia/Hong Kong","Asia/Hovd","Asia/Irkutsk","Asia/Jakarta","Asia/Jayapura","Asia/Jerusalem","Asia/Kabul","Asia/Kamchatka","Asia/Karachi","Asia/Kathmandu","Asia/Khandyga","Asia/Kolkata","Asia/Krasnoyarsk","Asia/Kuala Lumpur","Asia/Kuching","Asia/Kuwait","Asia/Macau","Asia/Magadan","Asia/Makassar","Asia/Manila","Asia/Muscat","Asia/Nicosia","Asia/Novokuznetsk","Asia/Novosibirsk","Asia/Omsk","Asia/Oral","Asia/Phnom Penh","Asia/Pontianak","Asia/Pyongyang","Asia/Qatar","Asia/Qostanay","Asia/Qyzylorda","Asia/Riyadh","Asia/Sakhalin","Asia/Samarkand","Asia/Seoul","Asia/Shanghai","Asia/Singapore","Asia/Srednekolymsk","Asia/Taipei","Asia/Tashkent","Asia/Tbilisi","Asia/Tehran","Asia/Thimphu","Asia/Tokyo","Asia/Tomsk","Asia/Ulaanbaatar","Asia/Urumqi","Asia/Ust-Nera","Asia/Vientiane","Asia/Vladivostok","Asia/Yakutsk","Asia/Yangon","Asia/Yekaterinburg","Asia/Yerevan","Atlantic/Azores","Atlantic/Bermuda","Atlantic/Canary","Atlantic/Cape Verde","Atlantic/Faroe","Atlantic/Madeira","Atlantic/Reykjavik","Atlantic/South Georgia","Atlantic/St Helena","Atlantic/Stanley","Australia/Adelaide","Australia/Brisbane","Australia/Broken Hill","Australia/Darwin","Australia/Eucla","Australia/Hobart","Australia/Lindeman","Australia/Lord Howe","Australia/Melbourne","Australia/Perth","Australia/Sydney","Europe/Amsterdam","Europe/Andorra","Europe/Astrakhan","Europe/Athens","Europe/Belgrade","Europe/Berlin","Europe/Bratislava","Europe/Brussels","Europe/Bucharest","Europe/Budapest","Europe/Busingen","Europe/Chisinau","Europe/Copenhagen","Europe/Dublin","Europe/Gibraltar","Europe/Guernsey","Europe/Helsinki","Europe/Isle of Man","Europe/Istanbul","Europe/Jersey","Europe/Kaliningrad","Europe/Kirov","Europe/Kyiv","Europe/Lisbon","Europe/Ljubljana","Europe/London","Europe/Luxembourg","Europe/Madrid","Europe/Malta","Europe/Mariehamn","Europe/Minsk","Europe/Monaco","Europe/Moscow","Europe/Oslo","Europe/Paris","Europe/Podgorica","Europe/Prague","Europe/Riga","Europe/Rome","Europe/Samara","Europe/San Marino","Europe/Sarajevo","Europe/Saratov","Europe/Simferopol","Europe/Skopje","Europe/Sofia","Europe/Stockholm","Europe/Tallinn","Europe/Tirane","Europe/Ulyanovsk","Europe/Uzhgorod","Europe/Vaduz","Europe/Vatican","Europe/Vienna","Europe/Vilnius","Europe/Volgograd","Europe/Warsaw","Europe/Zagreb","Europe/Zaporozhye","Europe/Zurich","Indian/Antananarivo","Indian/Chagos","Indian/Christmas","Indian/Cocos","Indian/Comoro","Indian/Kerguelen","Indian/Mahe","Indian/Maldives","Indian/Mauritius","Indian/Mayotte","Indian/Reunion","Pacific/Apia","Pacific/Auckland","Pacific/Bougainville","Pacific/Chatham","Pacific/Chuuk","Pacific/Easter","Pacific/Efate","Pacific/Fakaofo","Pacific/Fiji","Pacific/Funafuti","Pacific/Galapagos","Pacific/Gambier","Pacific/Guadalcanal","Pacific/Guam","Pacific/Honolulu","Pacific/Kanton","Pacific/Kiritimati","Pacific/Kosrae","Pacific/Kwajalein","Pacific/Majuro","Pacific/Marquesas","Pacific/Midway","Pacific/Nauru","Pacific/Niue","Pacific/Norfolk","Pacific/Noumea","Pacific/Pago Pago","Pacific/Palau","Pacific/Pitcairn","Pacific/Pohnpei","Pacific/Port Moresby","Pacific/Rarotonga","Pacific/Saipan","Pacific/Tahiti","Pacific/Tarawa","Pacific/Tongatapu","Pacific/Wake","Pacific/Wallis"]

	const reducer = useSalons();
	const [ state, dispatch ] = reducer;
	const { salons } = state;
	useEffect(
		() => {
			setSalon(salons.find(salon => salon.id === salonId));
			console.log("THIS SALON", salons.find(salon => salon.id === salonId))
		},
		[ salons ]
	);

	useEffect(() => {
		dispatch(getAllSalons());
		document.title = "Account Settings";
		mixpanel.track("PMA Settings - Account page accessed");
		getInvoices();
	}, [])
	

	const getInvoices = async () => {
		let r = await getStripeCustomerInvoices({
			salonId:salonId
		})
		console.log("r", r.data)
		setInvoices(r.data.invoices);
		setAccount(r.data.account.Items[0]);
		setCustomer(r.data.customer);
		setTimezone(r.data.account.Items[0].timeZone)
		setLoading(false);
	}

	const AccountNameInput = useRef<HTMLInputElement>(null);
	const AddressLine1Input = useRef<HTMLInputElement>(null);
	const CityOrSuburbInput = useRef<HTMLInputElement>(null);
	const StateInput = useRef<HTMLInputElement>(null);
	const PostcodeInput = useRef<HTMLInputElement>(null);
	const OwnerFirstNameInput = useRef<HTMLInputElement>(null);
	const OwnerLastNameInput = useRef<HTMLInputElement>(null);
	const PhoneInput = useRef<HTMLInputElement>(null);
	const EmailInput = useRef<HTMLInputElement>(null);

	const updateAccount = async () => {
		setSaving(true)
		let _accountDetails = {
			"id" : account.id,
			"email" : EmailInput.current?.value,
			"AccountName" : AccountNameInput.current?.value,
			"AddressLine1" :  AddressLine1Input.current?.value,
			"CityOrSuburb" :  CityOrSuburbInput.current?.value,
			"State" :  StateInput.current?.value,
			"Postcode" :  PostcodeInput.current?.value,
			"OwnerFirstName" :  OwnerFirstNameInput.current?.value,
			"OwnerLastName" :  OwnerLastNameInput.current?.value,
			"Phone" :  PhoneInput.current?.value,
			"stripeCustomerId" : customer.id,
			"timezone" : timezone
		}
		console.log('ad', _accountDetails);
		let out = await UpdateAWSAccount(_accountDetails);
		console.log('r',out)
		setLoading(false)
		setSaving(false)
	}

	return (
		<Layout>
			<Notification />
			<Container style={{paddingBottom: 100}}>
				<SettingsNavbar
					name="account"
					onChange={(path: string) =>
						history.push(`/${match.params.salonId}/${path}`)}
				/>
				<Grid container={true}>
					<Grid item={true} xs={12}>
						<Tooltip>Don't forget to press the Save button in the bottom right.</Tooltip>
					</Grid>
					<Grid item={true} xs={12} sm={6} md={6} style={{borderBottom: "1px solid black",  paddingBottom: 60}}>
						
							<h2>Account details</h2>
								{loading ? (
									<>Loading...</>
								) : (
									<>
										<InputContainer>
											<label>Account Name</label>
											<input
												type={"text"}
												name={"accountName"}
												ref={AccountNameInput}
												id="accountName"
												defaultValue={account.name}
											/>
										</InputContainer>
										<InputContainer>
										<label>Address Line 1</label>
										<input
											type={"text"}
											name={"addressLine1"}
											ref={AddressLine1Input}
											id="addressLine1"
											defaultValue={account.addressLine1}
										/>
										</InputContainer>
										<InputContainer>
										<label>City or Suburb</label>
										<input
											type={"text"}
											name={"cityOrSuburb"}
											ref={CityOrSuburbInput}
											id="cityOrSuburb"
											defaultValue={account.city}
										/>
										</InputContainer>
										<InputContainer>
										<label>State</label>
										<input
											type={"text"}
											name={"state"}
											ref={StateInput}
											id="state"
											defaultValue={account.state}
										/>
										</InputContainer>
										<InputContainer>
										<label>Postcode</label>
										<input
											type={"text"}
											name={"postcode"}
											ref={PostcodeInput}
											id="postcode"
											defaultValue={account.postcode}
										/>
										</InputContainer>
										<InputContainer>
										<label>Owner First Name</label>
										<input
											type={"text"}
											name={"ownerFirstName"}
											ref={OwnerFirstNameInput}
											id="ownerFirstName"
											defaultValue={account.firstName}
										/>
										</InputContainer>
										<InputContainer>
										<label>Owner Last Name</label>
										<input
											type={"text"}
											name={"ownerLastName"}
											ref={OwnerLastNameInput}
											id="ownerLastName"
											defaultValue={account.lastName}
										/>
										</InputContainer>
										<InputContainer>
										<label>Contact Phone</label>
										<input
											type={"text"}
											name={"phone"}
											ref={PhoneInput}
											id="phone"
											defaultValue={account.phone}
										/>
										</InputContainer>
										<InputContainer>
										<label>Contact Email</label>
										<input
											type={"text"}
											name={"email"}
											ref={EmailInput}
											id="email"
											defaultValue={account.email}
										/>	
										</InputContainer>

										<InputContainer>
										<label>Timezone</label>
										<NativeSelect id="timezones" value={timezone} onChange={(e) => {setTimezone(e.target.value)}}>
											{ timezones.map((timezone, i) => 
													<option value={timezone}>{timezone}</option>
												
											)}
										</NativeSelect>
										</InputContainer>
										<FixedFooter>
											<Button
												variant="outlined"
												size="small"
												onClick={updateAccount}
												color="primary"
												style={{
													backgroundColor: "black",
													color: "white",
													width: "150px",
													borderRadius: "20px",
													height: "60px",
												}}
											>
												{saving ? 'Saving...' : 'Save'}
											</Button>
										</FixedFooter>
									</>
								)}

								<PasswordComponent
									buttonText="Change Password"
									title={"Password"}
								/>
							</Grid>
							<Grid item={true} xs={12} sm={6} md={6} style={{borderBottom: "1px solid black",  paddingBottom: 60}}>

							{ state.salons.length > 1 ? (
								<>
									<h2>Salons</h2>
									{state.salons.map((s,i) => (
										<div>{s.name}</div>
									))}
								</>
								) : (
									<></>
								)
							}
							<h2>Plan</h2>
							<p>{account.plan} - {account.mirrors} mirror(s) - ${account.total}</p>
							<p><a style={{color:"black"}} href="mailto:info@piiqdigital.com?subject=Change plan&body=I want to change my piiq Pro plan to ...">Change plan</a>
							<br /><a style={{color:"black"}} href="mailto:info@piiqdigital.com?subject=Cancel plan&body=I want to cancel my piiq Pro plan">Cancel plan</a></p>
							<h2>Invoices</h2>
								{loading ? (
									<>Loading...</>
								) : (
									<>
									{invoices.data.length > 0 ? invoices?.data?.map((i) => {
										let options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' };
										let period_start = new Date(i.period_start * 1000).toLocaleDateString("en-US", options)
										return (<>
											<SettingsRow>
												<SalonColumn><a target="_blank" href={i.hosted_invoice_url}>{i.number}</a></SalonColumn>
												<SalonColumn><p>{period_start}</p></SalonColumn>
											</SettingsRow>
										</>)
									}) : "No invoices yet"} 
									</>
								)}
							</Grid>
						</Grid>
			</Container>
		</Layout>
	);
}
